import { Popover, PopoverProps } from "@mui/material";
import { useState } from "react";
import Flex from "../../components/Flex";

interface PopOverCreatorProps {
  triggerComponent: React.ReactNode;
  contentComponent: React.ReactNode;
  anchorOrigin?: PopoverProps["anchorOrigin"];
  transformOrigin?: PopoverProps["transformOrigin"];
}

/**
 * @param triggerComponent: React.ReactNode
 * @param contentComponent: React.ReactNode
 *
 *
 * @returns Popover component with trigger and content components
 *
 * @author [Rajkumar Rathod]
 */
const PopOverCreator = ({
  triggerComponent,
  contentComponent,
  anchorOrigin,
  transformOrigin,
}: PopOverCreatorProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const close = () => setAnchorEl(null);

  return (
    <Flex flexDirection={"column"} gap={1}>
      <Flex
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          handleOpen(e as any);
        }}
        sx={{ cursor: "pointer" }}
      >
        {triggerComponent}
      </Flex>

      <Popover
        open={Boolean(anchorEl)}
        onClose={close}
        anchorEl={anchorEl}
        anchorOrigin={
          anchorOrigin ?? {
            vertical: "bottom",
            horizontal: "right",
          }
        }
        transformOrigin={
          transformOrigin ?? {
            vertical: "top",
            horizontal: "right",
          }
        }
      >
        {contentComponent}
      </Popover>
    </Flex>
  );
};

export default PopOverCreator;
